import { breakpointsVuetify } from "@vueuse/core";
import {
    AppContentLayoutNav,
    ContentWidth,
    FooterType,
    HorizontalNavType,
    NavbarType,
} from "@layouts/enums";

export const layoutConfig = {
    app: {
        title: "my-layout",
        logo: h("img", { src: "/src/assets/logo.svg" }),
        contentWidth: ContentWidth.Boxed,
        contentLayoutNav: AppContentLayoutNav.Vertical,
        overlayNavFromBreakpoint: breakpointsVuetify.md,

        // isRTL: false,
        i18n: {
            enable: true,
        },
        iconRenderer: h("div"),
    },
    navbar: {
        type: NavbarType.Static,
        navbarBlur: true,
    },
    footer: {
        type: FooterType.Static,
    },
    verticalNav: {
        isVerticalNavCollapsed: false,
        defaultNavItemIconProps: { icon: "tabler-circle" },
    },
    horizontalNav: {
        type: HorizontalNavType.Static,
        transition: "none",
        popoverOffset: 0,
    },
    icons: {
        chevronDown: { icon: "tabler-chevron-down" },
        chevronRight: { icon: "tabler-chevron-right" },
        close: { icon: "tabler-x" },
        verticalNavPinned: { icon: "tabler-circle-dot" },
        verticalNavUnPinned: { icon: "tabler-circle" },
        sectionTitlePlaceholder: { icon: "tabler-minus" },
    },
};
